import { QueryClient, QueryCache } from '@tanstack/react-query';
import { isContextRequiredError } from './session/context-required';
import { useContextStore } from './session/context-store';

/** The app-wide query freshness window. Hooks that need a result-dependent window (ADR-029) fall back to this. */
export const DEFAULT_STALE_MS = 30_000

export const queryClient = new QueryClient({
  // A context-scoped query that fails with ACL_CONTEXT_REQUIRED means there is no
  // active context yet — drop the active context so the ContextGate shows the
  // picker rather than surfacing a raw error (T17 handover #4).
  //
  // Guard: suppress clearActive during a context switch (isSwitching=true spans
  // the switchContext round-trip AND the post-switch cache reset). Without this
  // guard, queries that become enabled immediately after setActive (e.g.
  // usePermissions in Sidebar) can fire against the gateway before it has
  // processed the new session and return ACL_CONTEXT_REQUIRED — driving a
  // clearActive → hasActiveContext=false → effect re-fires loop (T0023).
  queryCache: new QueryCache({
    onError: (error) => {
      if (isContextRequiredError(error)) {
        const state = useContextStore.getState();
        if (!state.isSwitching) {
          state.clearActive();
        }
      }
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: DEFAULT_STALE_MS,
      // Don't retry a "no active context" failure — it won't resolve by retrying.
      retry: (failureCount, error) => !isContextRequiredError(error) && failureCount < 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      onError: (error) => {
        console.error('[GraphQL Mutation Error]', error);
      },
    },
  },
});
